import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ContainerStyled = styled(Box).attrs({
  justifyContent: { sm: 'space-between' },
})`
  width: 100%;
`;

export const NonCatalogListItemStyled = styled(Box).attrs({
  justifyContent: { sm: 'space-between' },
  alignItems: { sm: 'center' },
  flexDirection: { sm: 'column' },
})`
  margin: 0;
  ${({ theme }) => css`
    background-color: ${theme.colors.purple[100]};
    border: 2px solid ${theme.colors.purple[500]};
    border-radius: ${theme.spacings[400]};
    height: 50px;
    width: 50px;
    overflow: hidden;
  `}
`;

export const NonCatalogListItemTextStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignSelf: { sm: 'end' },
})`
  margin: 0;
  ${({ theme }) => css`
    background-color: ${theme.colors.red[500]};
    height: 10px;
    width: 100%;
  `}
`;
